// import composables
import { useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { useTheme } from 'vuetify';
// import types
import SettingsStore from '@/store/settings/types/SettingsStore';
import SettingsLocalStorage from '@/constants/SettingsLocalStorage';
import Themes from '@/enums/Themes';
import { useStorage } from '@vueuse/core';
import SETTINGS_LOCAL_STORAGE from '@/constants/SettingsLocalStorage';
import ISettings from '@/interfaces/ISettings';
import { GoogleAnalytics } from '@/services/analytics/googleAnalytics';

export const useSettingsStore = defineStore('settings', {
  state: (): SettingsStore => ({
    theme: {
      activeTheme: useTheme().global.name,
      isThemeDark: useTheme().global.name.value == Themes.DARK,
    },
    settings: useStorage<ISettings>(
      SETTINGS_LOCAL_STORAGE,
      {} as ISettings // Provide a default value
    ).value,
  }),
  actions: {
    setTheme() {
      if (this.theme.activeTheme == Themes.LIGHT) {
        this.theme.isThemeDark = true;
        this.theme.activeTheme = useLocalStorage(SettingsLocalStorage, {
          theme: Themes.DARK,
        }).value.theme = Themes.DARK;
      } else {
        this.theme.isThemeDark = false;
        this.theme.activeTheme = useLocalStorage(SettingsLocalStorage, {
          theme: Themes.LIGHT,
        }).value.theme = Themes.LIGHT;
      }
    },
    setSettings(settings: ISettings) {
      this.settings = settings;
    },
    setUseDebugMode(useDebug: boolean) {
      this.settings.useDebug = useDebug;
      GoogleAnalytics.settingDebugToggle();
    },
    setUseSitemap(useSitemap: boolean) {
      GoogleAnalytics.settingSitemapToggle();
      this.settings.useSitemap = useSitemap
    }
  },
  getters: {
    getIsThemeDark(): boolean {
      return this.theme.activeTheme == Themes.DARK;
    },
    getIsDebugMode(): boolean {
      return this.settings.useDebug || false;
    },
    getIsUseSitemap(): boolean {
      return this.settings.useSitemap || false;
    }
  },
});
